export default __webpack_public_path__ + "797444d6c1f835ad4f9fb63fddfbe65f.png";